export default () => ({
  theFisrt: null,
  beenUpdated: false,
  setpTwocollapsibleOne: true,
  setpTwocollapsibleTwo: false,
  setpTwocollapsibleThree: false,
  show: false,
  registration: {
    attachment: {
      content: null,
      mime: null
    },
    name: null,
    entity_id: 1,
    country_register: null,
    state: null,
    document: null,
    record: null,
    birthdate: null,
    networks: {
      linkedin: null,
      lattes: null
    },
    bio: null
  },
  errors: {

  },
  date: new Date(),
  config: {
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    useCurrent: false,
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  nextStepButtonIsProfessionalSpeciality: [
    {
      icon: '',
      text: 'Especialidades Médicas',
      name: 'professional.record.specialities.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/record/registration/resources/data.js